import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/website/node_modules/smooth-doc/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "babel-plugin"
    }}><a parentName="h1" {...{
        "href": "#babel-plugin",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Babel plugin`}</h1>
    <p>{`This plugin adds support for `}<a parentName="p" {...{
        "href": "/docs/server-side-rendering"
      }}>{`Server Side Rendering`}</a>{` and automatic chunk names.`}</p>
    <h2 {...{
      "id": "usage"
    }}><a parentName="h2" {...{
        "href": "#usage",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Usage`}</h2>
    <p>{`Install the babel plugin first:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save-dev @loadable/babel-plugin
`}</code></pre>
    <p>{`Then add it to your babel configuration like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "plugins": ["@loadable/babel-plugin"]
}
`}</code></pre>
    <h2 {...{
      "id": "transformation"
    }}><a parentName="h2" {...{
        "href": "#transformation",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Transformation`}</h2>
    <p>{`The plugin transforms your code to be ready for Server Side Rendering, it turns a loadable call:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import loadable from '@loadable/component'

const OtherComponent = loadable(() => import('./OtherComponent'))
`}</code></pre>
    <p>{`into another one with some informations required for Server Side Rendering:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import loadable from '@loadable/component'
const OtherComponent = loadable({
  chunkName() {
    return 'OtherComponent'
  },

  isReady(props) {
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[this.resolve(props)]
    }

    return false
  },

  requireAsync: () =>
    import(/* webpackChunkName: "OtherComponent" */
    './OtherComponent'),

  requireSync(props) {
    const id = this.resolve(props)

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id)
    }

    return eval('module.require')(id)
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak('./OtherComponent')
    }

    return require('path').resolve(__dirname, './OtherComponent')
  },
})
`}</code></pre>
    <p>{`As you can see the "webpackChunkName" annotation is automatically added.`}</p>
    <p>{`On client side, the two code are completely compatible.`}</p>
    <p>{`Please note that babel must not be configured `}<a parentName="p" {...{
        "href": "https://babeljs.io/docs/en/options#comments"
      }}>{`to strip comments`}</a>{`, since the chunk name is defined in a comment.`}</p>
    <h2 {...{
      "id": "loadable-detection"
    }}><a parentName="h2" {...{
        "href": "#loadable-detection",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Loadable detection`}</h2>
    <p>{`The detection of a loadable component is based on the keyword "loadable". It is an opinionated choice, it gives you flexibility but it could also be restrictive.`}</p>
    <p>{`This code will not be transformed by the babel plugin:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import load from '@loadable/component'
const OtherComponent = load(() => import('./OtherComponent'))
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`load`}</inlineCode>{` function is not detected, you have to name it `}<inlineCode parentName="p">{`loadable`}</inlineCode>{`.`}</p>
    <p>{`It is restrictive, yes but it could gives you some flexibility. You can create your own loadable function. In the following example we create a custom loadable function with a custom fallback:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import baseLoadable from '@loadable/component'

function loadable(func) {
  return baseLoadable(func, { fallback: <div>Loading...</div> })
}

const OtherComponent = loadable(() => import('./OtherComponent'))
`}</code></pre>
    <h2 {...{
      "id": "magic-comments"
    }}><a parentName="h2" {...{
        "href": "#magic-comments",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Magic comments`}</h2>
    <p>{`To gives you flexibility and portability, the babel plugin supports magic comment. This way you can create portable "load" functions. To create a "load" function, you have to add `}<inlineCode parentName="p">{`/* #__LOADABLE__ */`}</inlineCode>{` comment above the declaration of your function (variable or property):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const loadOther = /* #__LOADABLE__ */ () => import('./OtherComponent')

const OtherComponent = loadable(loadOther)
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`loadOther`}</inlineCode>{` function will be transformed into an object, this way you can manipulate function and it is still portable!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      